import SupplierTable from './SupplierTable';

export default SupplierTable;